import {connect} from 'react-redux';
import {DesignChapter} from '@learningblocks/storybook-components';

import {getComponentProps} from './Technique.selector';

function mapStateToProps(state, ownProps) {
  return getComponentProps(state, ownProps);
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const Technique = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.Technique);
